import React, { useEffect } from "react";
import { obtenerUltimoPedido } from "../services/trackingService";
import { ResumenItemsPedido } from "./CarritoVista";
import {
  etiquetaCanal,
  etiquetaEstado,
  formatearMonto,
  formatearFechaHora,
  numeroPedidoVisible,
} from "../utils/pedidoDisplay";

/**
 * Pantalla de confirmación post-E6.
 * Muestra únicamente datos persistidos de la respuesta backend.
 */
export default function PedidoConfirmado({ onVolverCarta }) {
  const pedido = obtenerUltimoPedido();

  useEffect(() => {
    if (!pedido) {
      onVolverCarta?.();
    }
  }, [pedido, onVolverCarta]);

  if (!pedido) {
    return null;
  }

  const numeroPedido = numeroPedidoVisible(pedido);
  const canalLabel = etiquetaCanal(pedido.canal);
  const estadoLabel = etiquetaEstado(pedido.estado);
  const fechaLabel = formatearFechaHora(pedido.creadoEn);
  const subtotalLabel = formatearMonto(pedido.subtotal);
  const deliveryLabel = formatearMonto(pedido.montoDelivery);
  const totalLabel = formatearMonto(pedido.total);

  const mostrarDelivery =
    pedido.canal === "delivery" && pedido.montoDelivery != null;

  return (
    <div
      className="container py-5"
      style={{
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        maxWidth: 520,
      }}
    >
      <div
        className="bg-white rounded-4 shadow px-4 py-5 text-center"
        style={{ border: "1px solid #ececec" }}
      >
        <div
          className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
          style={{
            width: 72,
            height: 72,
            backgroundColor: "#e8f5e9",
            fontSize: 36,
          }}
          aria-hidden
        >
          ✓
        </div>

        <h1 className="fw-bold mb-2" style={{ fontSize: 28 }}>
          ¡Pedido enviado!
        </h1>
        {numeroPedido && (
          <p className="fw-bold mb-2" style={{ fontSize: 22 }}>
            Pedido N° {numeroPedido}
          </p>
        )}
        <p className="text-muted mb-4">
          Estamos preparando tu pedido.
        </p>

        <div
          className="text-start rounded-4 p-4 mb-4"
          style={{ backgroundColor: "#f8f9fa" }}
        >
          {numeroPedido && (
            <div className="mb-3">
              <div className="text-muted small">Número de pedido</div>
              <div className="fw-bold" style={{ fontSize: 22 }}>
                Pedido N° {numeroPedido}
              </div>
            </div>
          )}

          {estadoLabel && (
            <div className="mb-3">
              <div className="text-muted small">Estado</div>
              <div className="fw-semibold">{estadoLabel}</div>
            </div>
          )}

          {canalLabel && (
            <div className="mb-3">
              <div className="text-muted small">Canal</div>
              <div className="fw-semibold">{canalLabel}</div>
            </div>
          )}

          {fechaLabel && (
            <div className="mb-3">
              <div className="text-muted small">Fecha y hora</div>
              <div className="fw-semibold">{fechaLabel}</div>
            </div>
          )}

          <ResumenItemsPedido items={pedido.items || []} incrustado />

          <hr />

          {subtotalLabel && (
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">Subtotal</span>
              <span className="fw-semibold">{subtotalLabel}</span>
            </div>
          )}

          {mostrarDelivery && deliveryLabel && (
            <div className="d-flex justify-content-between mb-2">
              <span className="text-muted">Delivery</span>
              <span className="fw-semibold">{deliveryLabel}</span>
            </div>
          )}

          {totalLabel && (
            <div className="d-flex justify-content-between mt-2">
              <span className="fw-bold">Total</span>
              <span className="fw-bold" style={{ color: "#e53935", fontSize: 20 }}>
                {totalLabel}
              </span>
            </div>
          )}
        </div>

        <div className="d-grid gap-2">
          <button
            type="button"
            className="btn btn-dark rounded-pill fw-semibold py-2"
            onClick={onVolverCarta}
          >
            Volver a la carta
          </button>
        </div>
      </div>
    </div>
  );
}
